export default function MesuresConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('mesures');
}

MesuresConfiguration.$inject = ['$translatePartialLoaderProvider'];
